import React from 'react';
import type { LTWHP } from '../types';
import "./css/style.css";

interface Props {
    position: {
        boundingRect: LTWHP;
        rects: Array<LTWHP>;
    };
    onClick?: () => void;
    onMouseOver?: () => void;
    onMouseOut?: () => void;
    comment: {
        emoji: string;
        text: string;
    };
    isScrolledTo: boolean;
}

export const Highlight = ({
    position,
    onClick,
    onMouseOver,
    onMouseOut,
    comment,
    isScrolledTo,
}: Props) => {
    const { rects, boundingRect } = position;
    const isInteractive = Boolean(onClick || onMouseOver || onMouseOut);

    return (
        <div
            className={`Highlight highlight ${isScrolledTo ? "scrolledTo" : ""}`}
        >
            {comment ? (
                <div
                    className="Highlight__emoji emoji"
                    style={{
                        left: 20,
                        top: boundingRect.top,
                    }}
                >
                    {comment.emoji}
                </div>
            ) : null}
            <div className="Highlight__parts parts">
                {rects.map((rect) => {
                    const rectKey = `${rect.left}-${rect.top}-${rect.width}-${rect.height}-${rect.pageNumber ?? ''}`;
                    const interactiveProps = isInteractive ? {
                        onMouseOver,
                        onMouseOut,
                        onFocus: onMouseOver,
                        onBlur: onMouseOut,
                        onClick,
                        onKeyDown: (e: React.KeyboardEvent) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                onClick?.();
                            }
                        },
                        role: "button" as const,
                        tabIndex: 0,
                    } : {};

                    return (
                        <div
                            key={rectKey}
                            {...interactiveProps}
                            style={rect}
                            className="Highlight__part part"
                        />
                    );
                })}
            </div>
        </div>
    );
}